/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Grid, Header } from 'semantic-ui-react'
import { notify } from 'react-notify-toast';

import { useTranslation } from 'react-i18next';
import { removeCategorySet } from '../../services/Category/Category.service';
import { useMutation } from '@tanstack/react-query'

const RemoveSetConfirmation = ({ set, afterSubmit }) => {
  const [t] = useTranslation();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true)

    try {
      const result = await removeCategorySet(set.id, false);

      if (result.code === 'OVERRIDES_EXIST') {
          afterSubmit(result)
      } else {
          afterSubmit();
          notify.show(t('global.registerSuccess'), 'success');
      }
    } catch (e) {
      if (e.message === 'not_empty_set') {
        notify.show(`${t(`category_set.${e.message}`)}`, 'error');
      } else {
        notify.show(t('global.anErrorOccurred'), 'error');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <Form>
      <Grid css={css`
                .column { padding-top: .5rem !important; padding-bottom: .5rem !important; }
              `}>
        <Grid.Column width={16}>
          <Header>{t('category_set.remove_header', { name: set.name})}</Header>
        </Grid.Column>
        <Grid.Column width={16}>
          <div style={{ textAlign: 'right', marginTop: '10px' }}>
            <Button type="submit" color="red" loading={loading} disabled={loading} onClick={handleSubmit}>{t('global.delete')}</Button>
          </div>
        </Grid.Column>
      </Grid>
    </Form>
  )
}

const RemoveSetWithOverridesConfirmation = ({ set, afterSubmit, pointOfSales }) => {
    const [t] = useTranslation()

    const deleteSetMutation = useMutation({
        mutationFn: async () => {
            await removeCategorySet(set.id, true)
        },
        onSuccess: async () => {
            notify.show(t('global.registerSuccess'), 'success')
            afterSubmit()
        },
        onError: async () => {
            notify.show(t('global.anErrorOccurred'), 'error')
        }
    })

    return (
      <Form>
          <Grid css={css`
              .column { padding-top: .5rem !important; padding-bottom: .5rem !important; }
          `}>
              <Grid.Column width={16}>
                  <Header>{t('category_set.following_pos_impacted')}</Header>
                  <>
                      {pointOfSales.map(pointOfSale => (
                        <p key={pointOfSale.id}>{pointOfSale.name}</p>
                      ))}
                  </>
              </Grid.Column>
              <Grid.Column width={16}>
                  <div style={{ textAlign: 'right', marginTop: '10px' }}>
                      <Button
                        type="submit"
                        color="red"
                        loading={deleteSetMutation.isPending}
                        disabled={deleteSetMutation.isPending}
                        onClick={deleteSetMutation.mutate}>
                          {t('global.delete')}
                      </Button>
                  </div>
              </Grid.Column>
          </Grid>
      </Form>
    )
}

RemoveSetConfirmation.propTypes = {
  set: PropTypes.object.isRequired,
  afterSubmit: PropTypes.func.isRequired,
}

export {  RemoveSetConfirmation, RemoveSetWithOverridesConfirmation }
